import { Tree } from "fluid-framework";
import { useEffect, useRef } from "react";

import type { FluidSharedTree } from "../fluid.client.js";

interface UseContainerMigrationParams {
  sharedTree: FluidSharedTree | null;
  /** Must be a stable reference (e.g. wrapped in useCallback) to avoid re-subscribing on every render. */
  onOutdated: () => void;
}

export function useContainerMigration({
  sharedTree,
  onOutdated,
}: UseContainerMigrationParams): void {
  const handledRef = useRef(false);

  useEffect(() => {
    if (!sharedTree?.root) {
      return;
    }

    handledRef.current = false;

    const checkOutdated = () => {
      if (sharedTree.root.outdated && !handledRef.current) {
        handledRef.current = true;
        onOutdated();
      }
    };

    // Check immediately in case the container was already marked outdated.
    checkOutdated();

    const unsubscribe = Tree.on(sharedTree.root, "treeChanged", checkOutdated);

    return () => {
      unsubscribe();
    };
  }, [sharedTree, onOutdated]);
}
